<!--
 * @Author: baiwei
 * @Date: 2020-04-24 11:16:38
 * @LastEditors: fengzhongmei 996180799@qq.com
 * @LastEditTime: 2022-09-26 15:13:52
 * @Description: 描述
 * @Copyright: Cloud-Star. Co. Ltd. All rights reserved.
 -->
<template>
    <div>
        <rcTable ref="rcTable"
                 :tableAttr="tableAttr"
                 @onSelectChange="selectedChange">
            <div slot="tootipL">
                <Button type="primary"
                        :disabled="!hasPermission('CH0205')"
                        @click="condifureUser">
                    <i class="icon-plus-o-1"></i>{{$t('配置用户')}}
                </Button>
                <Button :disabled="!selected.length || !hasPermission('CH02100102')"
                        @click="remove()">
                    {{$t('移除')}}
                </Button>
            </div>
        </rcTable>
        <configureUser v-if="show"
                       ref="configureUser"
                       @refresh="refresh"></configureUser>
    </div>
</template>
<script>
import rcTable from '@c/basic/rcTable'
import configureUser from '../../components/configureuser'
import API from '@/service/api'
export default {
    name: 'user',
    components: {
        rcTable,
        configureUser
    },
    data () {
        return {
            show: false,
            selected: [],
            groupDisabledData: [],
            tableAttr: {
                source: {
                    type: 'staticData',
                    tableData: {
                        totalRows: 0,
                        dataList: []
                    }
                },
                // searchShow: true,
                // columnsChooseShow: true,
                isMultiSelect: true,
                pageData: {
                    pageWays: 'client'
                },
                referenceVal: 870,
                columns: [
                    // {
                    //     title: this.$t('ID'),
                    //     key: 'userSid',
                    //     className: 'ellipsis',
                    //     resizable: true,
                    //     width: 130,
                    //     render: (h, params) => h('span', { attrs: { title: params.row.userSid } }, params.row.userSid)
                    // },
                    {
                        title: this.$t('用户名'),
                        key: 'account',
                        resizable: true,
                        className: 'ellipsis',
                        width: 130,
                        render: (h, params) => h('incognito', { props: { sensitiveData: params.row.account, type: 'name' } }, params.row.account)
                    },
                    {
                        title: this.$t('姓名'),
                        key: 'realName',
                        resizable: true,
                        className: 'ellipsis',
                        width: 130,
                        render: (h, params) => h('incognito', { props: { sensitiveData: params.row.realName, type: 'name' } }, params.row.realName)
                    },
                    {
                        title: this.$t('电话'),
                        resizable: true,
                        key: 'mobile',
                        className: 'ellipsis',
                        width: 130,
                        render: (h, params) => h('incognito', { props: { sensitiveData: params.row.mobile } }, params.row.mobile)
                    },
                    {
                        title: this.$t('创建时间'),
                        key: 'createdDt',
                        className: 'ellipsis',
                        resizable: true,
                        minWidth: 150,
                        render: (h, params) => h('span', { attrs: { title: params.row.createdDt } }, params.row.createdDt)
                    },
                    {
                        title: this.$t('操作'),
                        // align: 'center',
                        resizable: false,
                        fixed: 'right',
                        width: 70,
                        render: (h, params) => {
                            return h('div', {
                                class: 'tbl-btn-div'
                            }, [
                                h('a', {
                                    class: { 'disabled-per': !this.hasPermission('CH02100102') || params.row._disabled },
                                    on: { click: () => this.hasPermission('CH02100102') && !params.row._disabled && this.remove(params.row.userSid) }
                                }, this.$t('移除'))
                            ])
                        }
                    }
                ]
            }
        }
    },
    created () {
    },
    methods: {
        initData (data, groupSid) {
            this.show = false
            this.groupSid = groupSid
            this.groupDisabledData = []
            // this.userSids = data.map(item => `${item.userSid}`)
            this.tableAttr.source.tableData = {
                totalRows: data.length,
                dataList: data.map(item => {
                    item._disabled = !item.parentSid
                    if (item.parentSid !== null) {
                        this.groupDisabledData.push(String(item.userSid))
                    }
                    return item
                })
            }
            this.$refs.rcTable.refreshTable()
            this.$nextTick(() => {
                this.show = true
            })
        },
        selectedChange (selection) {
            this.selected = selection
        },
        refresh () {
            this.$emit('refresh')
        },
        condifureUser () {
            this.$refs.configureUser.open(this.groupSid, this.groupDisabledData)
        },
        remove (id) {
            const userSids = id ? [id] : this.selected.map(item => item.userSid)
            this.$Modal.confirm({
                title: this.$t('移除'),
                content: this.$t(`确定要移除${id ? '该' : '所选'}用户关联`),
                okText: this.$t('确定'),
                cancelText: this.$t('取消'),
                onOk: () => {
                    // this.axios.delete(this.urlFormat(API.ACCESS_USERGROUP, true, [id])).then(res => {
                    //     this.refresh()
                    // })
                    this.axios.delete(this.urlFormat(API.ACCESS_USERGROUP_REMOVEUSER, false), {
                        data: {
                            userSids: userSids,
                            groupSids: [this.groupSid]
                        }
                    }).then(res => {
                        this.$emit('refresh')
                    })
                }
            })
        }
    }
}
</script>
<style lang="less" scoped>
</style>
